import { useEffect, useRef } from 'react';
import { supabase } from '@/lib/supabase';

// Generate or retrieve a session ID
function getSessionId(): string {
  let sid = sessionStorage.getItem('cb_session_id');
  if (!sid) {
    sid = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem('cb_session_id', sid);
  }
  return sid;
}

function getDeviceType(): string {
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
  if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(ua)) return 'mobile';
  return 'desktop';
}

interface TrackOptions {
  page: string;
  action?: string;
  customerPhone?: string;
  customerName?: string;
  city?: string;
  productName?: string;
  meta?: Record<string, unknown>;
}

export async function trackActivity(opts: TrackOptions): Promise<void> {
  try {
    const sessionId = getSessionId();
    const referrer = document.referrer || 'direct';
    const deviceType = getDeviceType();

    await supabase.from('visitor_activity').insert([{
      session_id: sessionId,
      page: opts.page,
      action: opts.action ?? 'page_view',
      customer_phone: opts.customerPhone ?? null,
      customer_name: opts.customerName ?? null,
      device_type: deviceType,
      city: opts.city ?? null,
      referrer: referrer,
      product_name: opts.productName ?? null,
      meta: opts.meta ?? {},
    }]);
  } catch {
    // Silent fail — tracking should never break the app
  }
}

export function usePageTracking(page: string, customerPhone?: string, customerName?: string, city?: string) {
  const tracked = useRef(false);

  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    trackActivity({ page, customerPhone, customerName, city });
  }, [page, customerPhone, customerName, city]);
}
